import { SKILL_CATEGORIES } from './mock'

export const getSkillCategoryNameBySlug = (slug: string) =>
  SKILL_CATEGORIES.find((s) => s.slug === slug)?.name
